import { render, staticRenderFns } from "./OnlyOnBigBox.vue?vue&type=template&id=5935c2ef&scoped=true&"
import script from "./OnlyOnBigBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./OnlyOnBigBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OnlyOnBigBox.vue?vue&type=style&index=0&id=5935c2ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935c2ef",
  null
  
)

export default component.exports